<ion-tabs (ionTabsDidChange)="onTabChanged($event)">
    <!-- Aktuelle Aufträge -->
    <ion-tab tab="aktuell">
        <div id="aktuell-page" class="tab-content">
            <app-mainmenu
                          [title]="title | translate"
                          [back]="true"
                          backUrl="/home"
                          [zaehlerText]="zaehlerText"
                          [menuButtonVisible]="menuButtonVisible"
                          (showMenu)="onShowMenu($event)"></app-mainmenu>

            <ion-content [scrollY]="false" *ngIf="!archivAnzeigen">
                <ion-searchbar [(ngModel)]="suchtext"
                               (ionChange)="onSearchChanged()"
                               (ionInput)="onSearchChanged()"
                               (ionCancel)="onSearchChanged()"
                               placeholder="{{ 'Suchen' | translate }}"
                               [debounce]="500"
                               *ngIf="searchbarSichtbar"
                               #searchbar></ion-searchbar>

                <ion-refresher slot="fixed" (ionRefresh)="doRefresh($event)">
                    <ion-refresher-content></ion-refresher-content>
                </ion-refresher>

                <ion-button class="tour-starten-button" expand="block" color="danger" appClick (clicked)="navigateTo($event, '/tour/start')" *ngIf="auftragstyp === 1 && (app.tourGestartet | async) === false && (app.tourStartenErforderlich | async)">
                    {{ 'TourStartenAlertButtonText' | translate }}
                </ion-button>

                <ng-container *ngIf="geladen">
                    <cdk-virtual-scroll-viewport *ngIf="items" [itemSize]="approxItemHeight" minBufferPx="900" maxBufferPx="1350" class="ion-content-scroll-host" #virtualScroll>
                        <ion-list>
                            <ion-item class="no-items" *ngIf="!items.length">
                                <ion-label *ngIf="!suchtext">
                                    <p>{{ 'KeineAuftraegeVorhanden' | translate }}</p>
                                </ion-label>
                                <ion-label *ngIf="suchtext">
                                    <p>{{ 'KeineAuftraegeGefunden' | translate }}</p>
                                </ion-label>
                            </ion-item>

                            <div *cdkVirtualFor="let item of items; let index = index;">
                                <ion-item-divider *ngIf="getHeader(item, index, items); let header">
                                    <ion-label>{{ header.title }} <span class="subtitle" *ngIf="header.subtitle">{{ header.subtitle }}</span></ion-label>
                                </ion-item-divider>

                                <app-auftragitem [auftrag]="item" [ansicht]="itemAnsicht" [style.height]="item.itemHeight" [style.minHeight]="minItemHeight"></app-auftragitem>
                            </div>

                            <ion-item class="no-items" *ngIf="anzahlNichtSichtbar" (click)="onNichtSichtbareAuftraegeClicked()">
                                <ion-label>
                                    <p *ngIf="anzahlNichtSichtbar > 1">{{ anzahlNichtSichtbar }} {{ 'weitere Aufträge vorhanden' | translate }}</p>
                                    <p *ngIf="anzahlNichtSichtbar === 1">1 {{ 'weiterer Auftrag vorhanden' | translate }}</p>
                                </ion-label>
                            </ion-item>

                            <!-- <ion-button expand="full" fill="clear" routerLink="/auftragsliste/archiv/{{auftragstyp}}" *ngIf="!archivAnzeigen">
                                <ion-ripple-effect></ion-ripple-effect>
                                <ion-icon name="albums-outline"></ion-icon> {{ 'Archiv' | translate }}
                            </ion-button>

                            <ion-button expand="full" fill="clear" appClick (clicked)="onAktuelleAuftraegeAnzeigen()" *ngIf="archivAnzeigen">
                                <ion-ripple-effect></ion-ripple-effect>
                                <ion-icon name="clipboard"></ion-icon> {{ 'Aktuelle Aufträge anzeigen' | translate }}
                            </ion-button> -->
                        </ion-list>
                    </cdk-virtual-scroll-viewport>
                </ng-container>
            </ion-content>
        </div>
    </ion-tab>

    <!-- Archiv -->
    <ion-tab tab="archive">
        <div id="archive-page" class="tab-content">
            <app-mainmenu
                          [title]="title | translate"
                          [back]="true"
                          backUrl="/home"
                          [menuButtonVisible]="menuButtonVisible"
                          (showMenu)="onShowMenu($event)"></app-mainmenu>

            <ion-content [scrollY]="false" *ngIf="archivAnzeigen">
                <ion-searchbar [(ngModel)]="suchtext" (ionChange)="onSearchChanged()" (ionCancel)="onSearchChanged()" placeholder="{{ 'Suchen' | translate }}" *ngIf="searchbarSichtbar" #searchbar></ion-searchbar>

                <ion-refresher slot="fixed" (ionRefresh)="doRefresh($event)">
                    <ion-refresher-content></ion-refresher-content>
                </ion-refresher>

                <ng-container *ngIf="geladen">
                    <cdk-virtual-scroll-viewport *ngIf="items" [itemSize]="approxItemHeight" minBufferPx="900" maxBufferPx="1350" class="ion-content-scroll-host" #virtualScroll>
                        <ion-list>
                            <ion-item class="no-items" *ngIf="!items.length">
                                <ion-label *ngIf="!suchtext">
                                    <p>{{ 'KeineAuftraegeVorhanden' | translate }}</p>
                                </ion-label>
                                <ion-label *ngIf="suchtext">
                                    <p>{{ 'KeineAuftraegeGefunden' | translate }}</p>
                                </ion-label>
                            </ion-item>

                            <div *cdkVirtualFor="let item of items; let index = index;">
                                <ion-item-divider *ngIf="getHeader(item, index, items); let header">
                                    <ion-label>{{ header.title }} <span class="subtitle" *ngIf="header.subtitle">{{ header.subtitle }}</span></ion-label>
                                </ion-item-divider>

                                <app-auftragitem [auftrag]="item" [ansicht]="itemAnsicht" [style.height]="item.itemHeight" [style.minHeight]="minItemHeight"></app-auftragitem>
                            </div>
                        </ion-list>
                    </cdk-virtual-scroll-viewport>
                </ng-container>
            </ion-content>
        </div>
    </ion-tab>

    <ion-tab tab="karte" *ngIf="isKarteVerfuegbar">
        <div class="tab-content" *ngIf="activeTab === 'karte'">
            <app-mainmenu
                          [title]="title | translate"
                          [back]="true"
                          backUrl="/home"
                          [menuButtonVisible]="menuButtonVisible"
                          (showMenu)="onShowKarteMenu($event)"></app-mainmenu>

            <ion-content>
                <app-karte-widget [auftraege]="alleAuftraege" #karteWidget></app-karte-widget>
            </ion-content>
        </div>
    </ion-tab>

    <ion-tab-bar slot="bottom">
        <ion-tab-button tab="aktuell">
            <ion-icon name="list-outline"></ion-icon>
            {{ 'Aufträge' | translate }}
        </ion-tab-button>
        <ion-tab-button tab="karte" *ngIf="isKarteVerfuegbar">
            <ion-icon name="map-outline"></ion-icon>
            {{ 'Karte' | translate }}
        </ion-tab-button>
        <ion-tab-button tab="archive">
            <ion-icon name="archive-outline"></ion-icon>
            {{ 'Archiv' | translate }}
        </ion-tab-button>
    </ion-tab-bar>
</ion-tabs>